export interface AnchorProps {
	anchorName: string;
}

export const Anchor: React.VFC<AnchorProps> = ({ anchorName }) => <div id={anchorName}></div>;
